import { Icon } from "../Icons";

export const LoadingOverlay = () => (
  <div className="absolute top-0 left-0 h-full w-full z-50 bg-black bg-opacity-30 flex justify-center items-center rounded">
    <Icon.Loading size="28" />
  </div>
);
